module.exports = __webpack_public_path__ + "static/01-5f25148caebe2c370957955ea2d95579.jpg";